// Helper para ordenar y formatear listas de cursos SCORM en selects
export const sortScorms = (scorms, sortBy = 'alpha') => {
  const list = Array.isArray(scorms) ? [...scorms] : [];
  if (sortBy === 'recent') {
    return list.sort((a, b) => {
      const da = new Date(a.updatedAt || a.createdAt || 0).getTime();
      const db = new Date(b.updatedAt || b.createdAt || 0).getTime();
      return db - da;
    });
  }
  return list.sort((a, b) => {
    const ta = (a.title || a.id || '').toLowerCase();
    const tb = (b.title || b.id || '').toLowerCase();
    return ta.localeCompare(tb);
  });
};

export const formatShortDate = (dateStr) => {
  if (!dateStr) return '';
  try {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return '';
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yy = String(d.getFullYear()).slice(-2);
    return `${dd}/${mm}/${yy}`;
  } catch (e) {
    return '';
  }
};

export const scormOptionLabel = (s) => {
  const title = s.title || s.id || 'SCORM';
  const date = formatShortDate(s.updatedAt || s.createdAt);
  return date ? `${title} (${date})` : title;
};
